import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import DynamicSelect from "common/Select/Select";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslation } from "react-i18next";
interface InventoryServicesTableProps {
  form?: any;
  columns: any[];
  handleInputChange: (
    index: number,
    columnId: string,
    value: any,
    typeName: string,
    type: string
  ) => void;
  rows: any[];
  typeName: string;
  services?: any[];
  currency?: string;
  DeleteItem: (row: any, typeName: string, index?: number) => void;
  params?: any;
  handleItem?: (row: any, typeName: string, action: string) => void;
  checkStatus?: number | null;
  viewDelete?: boolean;
  handleDropdownActions: (typeName: string, action: 'searchIt' | 'loadNext', search?: string, table?: string) => void;
  dropdownPage: number; 
  searchLoading: string | null; 
  dropdownSearchTerm: any; 
  setDropdownSearchTerm: any;
  setDropdownPage: any;
  servicesResponse: any;
}

export const InventoryServicesTable: React.FC<InventoryServicesTableProps> = ({
  form,
  columns,
  handleInputChange,
  rows,
  typeName,
  services,
  currency,
  DeleteItem,
  params,
  handleItem,
  checkStatus,
  viewDelete,
  handleDropdownActions,
  servicesResponse,
  dropdownPage, searchLoading, dropdownSearchTerm, setDropdownSearchTerm, setDropdownPage
}) => {
  const { t } = useTranslation();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const previousValueRef = React.useRef<string | number | null>(null);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const visibleRows = React.useMemo(
        () =>
          (rows || [])?.slice(
            page * rowsPerPage,
            page * rowsPerPage + rowsPerPage
          ),
        [page, rowsPerPage, rows]
      );

  return (
    <Box sx={{ width: "100%" }} id="inventorytable">
      <TableContainer>
        <Table
          sx={{ minWidth: 750 }}
          aria-labelledby="tableTitle"
          size={"small"}
        >
          <TableHead>
            <TableRow>
              {columns
                .filter(
                  (column) =>
                    column.id !== "serviceId" && column.id !== "serviceCode"
                )
                .map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.numeric ? "right" : "left"}
                    padding={column.disablePadding ? "none" : "normal"}
                    sortDirection={false}
                  >
                    <span className="font-bold">{column.label}</span>
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {visibleRows.map((row, index) => {
              const labelId = `enhanced-table-checkbox-${index}`;
              return (
                <TableRow
                  hover
                  tabIndex={-1}
                  key={row.id}
                  sx={{ cursor: "pointer" }}
                >
                  {columns
                    .filter(
                      (column) =>
                        column.id !== "serviceId" && column.id !== "serviceCode"
                    )
                    .map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.numeric ? "right" : "left"}
                        padding={column.disablePadding ? "none" : "normal"}
                        component={
                          column.id === "serviceName" ? "th" : undefined
                        }
                        id={column.id === "serviceName" ? labelId : undefined}
                        scope={column.id === "serviceName" ? "row" : undefined}
                        sx={{
                          width: column.id === "serviceName" ? "200px" : "auto",
                        }}
                      >
                        {column.id === "serviceName" ? (
                          <Controller
                            name={`${typeName}.${index}.${column.id}`}
                            control={form.control}
                            render={({ field }) => (
                              <Box
                                sx={{
                                  "& .dropdown": { height: "0 !important" },
                                }}
                              >
                                <DynamicSelect
                                  label=""
                                  {...field}
                                  value={form.watch(`${typeName}.${index}.${column.id}`) ? {
                                    value: form.watch(`${typeName}.${index}.serviceId`),
                                    label: form.watch(`${typeName}.${index}.serviceName`) || "" + " " + form.watch(`${typeName}.${index}.serviceCode`) || "",
                                    serviceCode: form.watch(`${typeName}.${index}.serviceCode`),
                                  } : null}
                                  options={services?.map(
                                    (service: {
                                      id: number;
                                      title: string;
                                      serviceCode: string;
                                    }) => ({
                                      value: service.id,
                                      label:
                                        service.title +
                                        ` ` +
                                        service.serviceCode,
                                      serviceCode: service.serviceCode,
                                    })
                                  )}
                                  isSearchable
                                  onChange={(selectedOption: any) => {
                                    field.onChange(selectedOption, column.type);
                                    handleInputChange(
                                      index,
                                      "serviceId",
                                      selectedOption.value,
                                      typeName,
                                      column.type
                                    );
                                    handleInputChange(
                                      index,
                                      "serviceName",
                                      selectedOption.label,
                                      typeName,
                                      column.type
                                    );
                                    handleInputChange(
                                      index,
                                      "serviceCode",
                                      selectedOption.serviceCode,
                                      typeName,
                                      column.type
                                    );
                                    handleInputChange(index, "quantity", 1, typeName, column.type);
                                    form.setValue(
                                      `${typeName}.${index}.${"serviceId"}`,
                                      selectedOption.value
                                    );
                                    form.setValue(
                                      `${typeName}.${index}.${"serviceName"}`,
                                      selectedOption.label
                                    );
                                    form.setValue(
                                      `${typeName}.${index}.${"serviceCode"}`,
                                      selectedOption.serviceCode
                                    );
                                    form.setValue(`${typeName}.${index}.${"quantity"}`, 1);
                                    if (params?.id && !row.id)
                                      handleItem?.(row, typeName, "create");
                                    else if (params?.id && row.id)
                                      handleItem?.(row, typeName, "update");
                                  }}
                                  isDisabled={checkStatus === 2 || checkStatus === 3 || checkStatus === 4}
                                  isLoading={searchLoading === `${typeName}.${index}.${column.id}`}
                                  creatable={(!params?.id && (typeName === "purchaseOrderSvc" || typeName === "purchaseInvoiceService" || typeName === "pCDNoteService")) ? true : false}
                                  onInputChange={(search: string, { action }: { action: string }) => {
                                    if(action === 'input-change' || 
                                      (action !== 'set-value' && action !== 'menu-close' && action !== 'input-blur')
                                    ) handleDropdownActions(`${typeName}.${index}.${column.id}`, 'searchIt', search, 'inventoryServices');
                                    else if(action === 'input-blur' || action === 'menu-close') {
                                      if(dropdownSearchTerm || dropdownPage > 1) handleDropdownActions(`${typeName}.${index}.${column.id}`, 'searchIt', '', 'inventoryServices');
                                      else setDropdownSearchTerm('');
                                      setDropdownPage(1);
                                    }
                                  }}
                                  onMenuScrollToBottom={() => {if(!(servicesResponse?.pages[0]?.data as any).last) handleDropdownActions(`${typeName}.${index}.${column.id}`, 'loadNext', dropdownSearchTerm, 'inventoryServices')}}
                                  page={dropdownPage || 1}
                                />
                              </Box>
                            )}
                          />
                        ) : column.id === "total" ? (
                          <span className="font-bold">
                            {new Intl.NumberFormat(
                              "en-US",
                              currency
                                ? {
                                    style: "currency",
                                    currency: currency || "",
                                  }
                                : {}
                            ).format(
                              parseInt(
                                form.watch(`${typeName}.${index}.${"quantity"}`)
                              ) *
                                (parseFloat(
                                  form.watch(
                                    `${typeName}.${index}.${"unitPrice"}`
                                  )
                                ) -
                                  (parseFloat(
                                    form.watch(
                                      `${typeName}.${index}.${"unitPrice"}`
                                    )
                                  ) *
                                    parseFloat(
                                      form.watch(
                                        `${typeName}.${index}.${"discount"}`
                                      ) || 0
                                    )) /
                                    100) || 0
                            )}
                          </span>
                        ) : column.id === "discount" ? ( // Added validation for discount
                          <Controller
                            name={`${typeName}.${index}.${column.id}`}
                            control={form.control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                type="number"
                                placeholder={t("discount")}
                                title={t("discount")}
                                fullWidth
                                onChange={(e) => {
                                  let value = parseInt(e.target.value);
                                  if (value < 0) value = 0; // Ensure discount is not less than 0
                                  if (value > 100) value = 100; // Ensure discount is not greater than 100
                                  handleInputChange(
                                    index,
                                    column.id,
                                    value,
                                    typeName,
                                    column.type
                                  );
                                  field.onChange(value);
                                }}
                                onBlur={(e) => {
                                  if (e.target.value === "") {
                                    field.onChange("0");
                                    handleInputChange(index, column.id, parseInt(e.target.value) || 0, typeName, column.type);
                                  }
                                }}
                                defaultValue={0}
                                disabled={checkStatus === 2 || checkStatus === 3 || checkStatus === 4}
                              />
                            )}
                          />
                        ) : (
                          <Controller
                            name={`${typeName}.${index}.${column.id}`}
                            control={form.control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                type={column.type}
                                placeholder={column.label}
                                title={column.label}
                                fullWidth
                                onChange={(e) => {
                                  let value: string | number = e.target.value;
                                  if (column.id === "quantity")
                                    value = Math.max(
                                      0,
                                      Math.floor(Number(value))
                                    );
                                  if (
                                    column.type === "number" &&
                                    (Number(value) < 0 || !Number(value))
                                  )
                                    value = "";
                                  handleInputChange(
                                    index,
                                    column.id,
                                    value,
                                    typeName,
                                    column.type
                                  );
                                  field.onChange(value);
                                }}
                                onFocus={(e) => {
                                  if (e.target.value === "0") {
                                    e.target.value = "";
                                    field.onChange("");
                                  }
                                  params?.id
                                    ? (previousValueRef.current =
                                        e.target.value)
                                    : "";
                                }}
                                onBlur={(e) => {
                                  if (column.id === "quantity" && (e.target.value === "" || Number(e.target.value) < 1)) {
                                    e.target.value = "1"; 
                                    field.onChange("1");
                                    handleInputChange(index, column.id, 1, typeName, column.type);
                                  } else if (e.target.value === "" && column.type === "number") {
                                    e.target.value = "0";
                                    field.onChange("0");
                                    handleInputChange(index, column.id, 0, typeName, column.type);
                                  }
                                  if (params?.id && !row.id) {
                                    if (
                                      previousValueRef.current !==
                                      e.target.value
                                    ) {
                                      handleItem?.(row, typeName, "create");
                                    }
                                  } else if (params?.id && row.id) {
                                    if (
                                      previousValueRef.current !==
                                      e.target.value
                                    ) {
                                      handleItem?.(row, typeName, "update");
                                    }
                                  }
                                }}
                                defaultValue={
                                  column.id === "unitPrice" ||
                                  column.id === "discount"
                                    ? 0
                                  : column.id === "quantity" ? 1
                                    : ""
                                }
                                disabled={checkStatus === 2 || checkStatus === 3 || checkStatus === 4}
                              />
                            )}
                          />
                        )}
                      </TableCell>
                    ))}
                  {row.id || viewDelete ? (
                    <TableCell
                      onClick={() => {
                        if (checkStatus === 1 || !params?.id) {
                          DeleteItem(row, typeName, index);
                          // columns.map((column) =>
                          //   form.resetField(`${typeName}.${index}.${column.id}`)
                          // );
                        }
                      }}
                      className="hide-on-print"
                    >
                      <DeleteIcon />
                    </TableCell>
                  ) : null}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[50, 100]}
        component="div"
        count={(rows || []).length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        className="hide-on-print"
        labelRowsPerPage={t("rowsPerPage")}
      />
    </Box>
  );
};
